import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import React, { useState } from "react";
import "./css/TicketSidebar.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTicket,
  faCirclePlus,
  faBoxesStacked,
  faGear,
  faRightFromBracket,
} from "@fortawesome/free-solid-svg-icons";

axios.defaults.withCredentials = true;

const TicketSidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const pathname = location.pathname;
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const [logoutError, setLogoutError] = useState("");
  const isTicketsActive =
    pathname === "/customer/tickets" ||
    pathname.startsWith("/customer/tickets/");

  const isNewTicketActive =
    pathname === "/customer/assets" || pathname.startsWith("/customer/assets/");

  const isSettingsActive =
    pathname === "/customer/setting" ||
    pathname.startsWith("/customer/setting/");

  const isAssetsActive =
    pathname === "/customer/assets-list" ||
    pathname.startsWith("/customer/assets-list/");

  // const isUploadStandardMAEnquiryActive =
  //   pathname === "/customer/upload-ma-enquiry" || pathname.startsWith("/customer/upload-ma-enquiry/");

  const handleLogout = () => {
    setLogoutError("");
    setShowLogoutConfirm(true);
  };

  const confirmLogout = async () => {
    try {
      setLogoutError("");

      await axios.post(
        "/customer/logout",
        {},
        { withCredentials: true },
      );

      setShowLogoutConfirm(false);
      navigate("/home");
    } catch (err) {
      console.error("Logout failed:", err);
      setLogoutError("ออกจากระบบไม่สำเร็จ กรุณาลองใหม่อีกครั้ง");
    }
  };

  const cancelLogout = () => {
    setShowLogoutConfirm(false);
    setLogoutError("");
  };

  return (
    <>
      <aside className="tsidebar-wrapper">
        {/* <div className="tsidebar-title">Menu</div> */}

        <ul className="tsidebar-menu">
          <li className="tsidebar-menu-item">
            <button
              type="button"
              className={`tsidebar-menu-button ${isTicketsActive ? "tsidebar-menu-button--active" : ""}`}
              onClick={() => navigate("/customer/tickets")}
            >
              <FontAwesomeIcon icon={faTicket} className="tsidebar-menu-icon" />
              <span>Ticket</span>
            </button>
          </li>

          <li className="tsidebar-menu-item">
            <button
              type="button"
              className={`tsidebar-menu-button ${isNewTicketActive ? "tsidebar-menu-button--active" : ""}`}
              onClick={() => navigate("/customer/assets")}
            >
              <FontAwesomeIcon
                icon={faCirclePlus}
                className="tsidebar-menu-icon"
              />
              <span>Open a New Ticket</span>
            </button>
          </li>

          <li className="tsidebar-menu-item">
            <button
              type="button"
              className={`tsidebar-menu-button ${isAssetsActive ? "tsidebar-menu-button--active" : ""}`}
              onClick={() => navigate("/customer/assets-list")}
            >
              <FontAwesomeIcon
                icon={faBoxesStacked}
                className="tsidebar-menu-icon"
              />
              <span>Assets</span>
            </button>
          </li>

          <li className="tsidebar-menu-item">
            <button
              type="button"
              className={`tsidebar-menu-button ${isSettingsActive ? "tsidebar-menu-button--active" : ""}`}
              onClick={() => navigate("/customer/setting")}
            >
              <FontAwesomeIcon icon={faGear} className="tsidebar-menu-icon" />
              <span>Setting</span>
            </button>
          </li>

          <li className="tsidebar-menu-item">
            <button
              type="button"
              className="tsidebar-menu-button"
              onClick={handleLogout}
            >
              <FontAwesomeIcon
                icon={faRightFromBracket}
                className="tsidebar-menu-icon"
              />
              <span>Log Out</span>
            </button>
          </li>
        </ul>

        {showLogoutConfirm && (
          <div className="logout-modal-overlay">
            <div className="logout-confirm-modal">
              <h3>ยืนยันออกจากระบบ</h3>

              <p>ต้องการออกจากระบบใช่หรือไม่?</p>

              {logoutError && (
                <div className="logout-error-message">{logoutError}</div>
              )}

              <div className="logout-confirm-actions">
                <button
                  type="button"
                  className="logout-confirm-btn"
                  onClick={confirmLogout}
                >
                  ออกจากระบบ
                </button>

                <button
                  type="button"
                  className="logout-cancel-btn"
                  onClick={cancelLogout}
                >
                  ยกเลิก
                </button>
              </div>
            </div>
          </div>
        )}
      </aside>
    </>
  );
};

export default TicketSidebar;
